<template>
  <div id="operatemonth">
    <!-- <span v-loading.fullscreen.lock="fullscreenLoading"></span> -->
    <CommonLoading ref="commonLoader"></CommonLoading>
    <div class="trader-body">
      <!--<div class="gppzys">
        <span>配资优势</span>
        <img src="../assets/img/cpic.png">
      </div>
      <ul class="gppzys-nr">
        <li>
          <img src="../assets/img/pzfqcg.png">
          <div class="gppzys-r">
            <p>配资发起成功</p>
            <p>5分钟内下户(开盘前下户)</p>
          </div>
          <div class="clear"></div>
        </li>
        <li>
          <img src="../assets/img/cpyltq.png">
          <div class="gppzys-r">
            <p>配资盈利提取</p>
            <p>5分钟到会员账户</p>
          </div>
          <div class="clear"></div>
        </li>
        <li>
          <img src="../assets/img/txmdz.png">
          <div class="gppzys-r">
            <p>提现秒到账</p>
            <p>5分钟内到达银行卡</p>
          </div>
          <div class="clear"></div>
        </li>
        <li style="margin-right:0">
          <img src="../assets/img/mccp.png">
          <div class="gppzys-r">
            <p>100%满仓配资</p>
            <p>单支股票无仓位限制</p>
          </div>
          <div class="clear"></div>
        </li>
        <div class="clear"></div>
      </ul>
      <div class="gppzys">
        <span>股票配资流程</span>
        <img src="../assets/img/cpic.png">
      </div>
      <div class="gppzlc">
        <img src="../assets/img/peiziimg2.jpg">
      </div>-->
      <div class="trader-at">
        <el-card class="box-card" shadow="never">
          <el-row>
            <el-col :span="20">
              <el-form ref="form" label-width="150px" label-position="right">
                <el-form-item v-if="direction_capital_enable==1 && is_short_trading_enable==1">
                  <span class="assist_title" style="text-align: center;margin-left:-130px!important;color:#606266">{{ $t('operateday.directionCapital') }}:</span>
                  <label class="radio-wrap">
                    <input type="radio" name="scale" :checked="direction_capital === 0" @click="toggleRadio(0)" />
                    {{ $t('operateday.longTradingLabel') }}
                  </label>
                  <label class="radio-wrap">
                    <input type="radio" name="scale" :checked="direction_capital === 1" @click="toggleRadio(1)" />
                    {{ $t('operateday.shortTradingLabel') }}
                  </label>
                </el-form-item>

                <el-form-item>
                  <span slot="label" class="assist_title">{{ $t('operatevip.deposit') }}:</span>
                  <el-input v-model.number="principal" :placeholder="info.explain" type="number"
                    @keyup.native="principalChange" @wheel.prevent style="width: 40%" @blur="isMultiple" @wheel.native.prevent></el-input>
                  <p class="infoColor">{{ info.explain }}</p>
                </el-form-item>
                <el-form-item>
                  <span slot="label" class="assist_title">{{ $t('operateday.managementFee') }}:</span>

                  <div class="multiple_box" v-for="(item, index) in currentMultiple" :key="index">
                    <div class="multiple" :class="{ capital_ul2_active: cut == index }" @click="setCut(index, item)">
                      <a href="javascript:void(0);">
                        <p class="multiple_detail">
                          {{ item[0] }}{{ $t('operatevip.times') }}
                        </p>
                        <p class="multiple_rate">{{ $t('operatevip.monthlyIntrest') }}{{ item[2] }}%</p>
                        <p class="multiple_money">{{ parseFloat(item[3]).toFixed(2) }}{{ $t('operatevip.yuan') }}</p>
                      </a>
                    </div>
                  </div>


                  <!-- <el-row :gutter="10">
                     <el-col
                       :span="4"
                       v-for="(item,index) in currentMultiple"
                       :key="index">
                       <div class="multiple"     :class="{capital_ul2_active: cut == index}"  @click="setCut(index,item)">
                         <a href="javascript:void(0);">
                           <p class="multiple_detail">
                             {{item[0]}}倍
                           </p>
                           <p class="multiple_rate">月利率{{item[2]}}%</p>
                           <p class="multiple_money">{{item[3]}}{{ $t('operatevip.yuan') }}</p>
                         </a>
                       </div>
                     </el-col>
                   </el-row>-->
                </el-form-item>
                <el-form-item>
                  <span slot="label" class="assist_title">{{ $t('operatevip.managementFee') }}:</span>
                  <p>
                    <span class="red">{{ fee }}{{ $t('operatevip.yuan') }}/</span>{{ $t('operatevip.month') }}（{{$t('operatevip.allocation')}}{{ parseFloat(money).toFixed(2) }} X {{$t('opeatemonth.intrestRate')}}{{ pitchMultiple }}%）<span
                      class="infoColor">{{$t('operatevip.automaticRenewal')}}</span>
                  </p>
                </el-form-item>
                <el-form-item>
                  <span slot="label" class="assist_title">{{ $t('operatevip.fundingInfo') }}:</span>
                  <div class="money_info">
                    <table>
                      <tr>
                        <td>
                          <span class="info_title">{{ $t('operatevip.totalAllocation') }}</span>
                        </td>
                        <td>
                          <span>
                            {{ parseFloat(allMoney).toFixed(2) }}{{ $t('operatevip.yuan') }}={{ principal }}({{$t('operatevip.deposit')}})+
                            {{ parseFloat(money).toFixed(2) }}{{ $t('operatevip.yuan') }}({{$t('operatevip.allocation')}})
                          </span>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <span class="info_title">{{ $t('operatevip.lossWarning') }}<el-tooltip class="item" effect="dark"
                              :content="$t('operate.fundBelowWarning')" placement="top-start"><i
                                class="el-icon-question red"></i></el-tooltip></span>
                        </td>
                        <td>
                          <span>
                            {{ parseFloat(warning).toFixed(2) }}{{ $t('operatevip.yuan') }}（{{ $t('opeatevip.warningLine') }} = {{$t('operatevip.allocation')}} + {{$t('operatevip.deposit')}} X {{ info.warning }}）
                          </span>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <span class="info_title">{{ $t('operatevip.lossClosingLine') }}<el-tooltip class="item" effect="dark"
                              :content="$t('operate.fundbelowLiquidation')" placement="top-start"><i
                                class="el-icon-question red"></i></el-tooltip></span>
                        </td>
                        <td>
                          <span>
                            {{ parseFloat(close).toFixed(2) }}{{ $t('operatevip.yuan') }}（{{$t('operatevip.closeLine')}} = {{$t('operatevip.allocation')}} + {{$t('operatevip.deposit')}} X {{ info.close }}）
                          </span>
                        </td>
                      </tr>
                    </table>
                  </div>
                </el-form-item>
                <el-form-item>
                  <p>
                    <input type="checkbox" class="check" v-model="agree" style="padding: 2px;border: 1px solid var(--baseColor);height: 20px;width: 20px;">
                    <span>{{ $t('operatevip.agree') }}</span>
                    <router-link to="/operate/protocol">{{ $t('operatevip.agreement') }}</router-link>
                  </p>
                  <p><span class="info_title" style="color: #ca3c4d;">{{ $t('operatevip.payment') }}:{{ payMoney }} </span>{{ $t('operatevip.deposit') }}{{ principal }}{{ $t('operatevip.yuan') }}+{{ $t('operatevip.managementFee') }}{{ fee }}{{ $t('operatevip.yuan') }}/{{ $t('operatevip.month') }}-{{ $t('operatevip.ticket') }}{{
                    (Number(voucher_management)).toFixed(2) }}{{ $t('operatevip.yuan') }}/{{ $t('operatevip.month') }}</p>
                </el-form-item>
                <el-form-item>
                  <el-button type="primary" style="width: 100%;color: #FFFFFF;background-color: var(--baseColor);border-color:var(--baseColor)" @click="operateBtn">{{$t('operatevip.allocateFund')}}</el-button>
                  <p class="center">{{ $t('operatevip.balance') }}:{{ user.cash.toFixed(2) }}{{ $t('operatevip.yuan') }} &nbsp; {{ $t('operatevip.ticket') }}:{{ user.voucher_management.toFixed(2) }}{{ $t('operatevip.yuan') }}</p>
                </el-form-item>
                <el-form-item>

                </el-form-item>
              </el-form>
            </el-col>
          </el-row>
        </el-card>
      </div>
      <!--<div class="gppzys">
        <span>选择配资方案</span>
        <img src="../assets/img/cpic.png">
      </div>
      <div class="trader-at">
        <div class="trader-at-l">
          <p class="trader-at-tit">第一步：输入投资本金({{info.min_num}}-{{info.max_num}})</p>
          <el-input
            class="operate-input"
            v-model.number="principal"
            :placeholder="info.explain"
            id="input1"
            type="number"
            @keyup.native="principalChange"
          ></el-input>
          <p class="note">备注：{{info.explain}}</p>
          <p class="trader-at-tit">第二步：选择获得资金(选择杠杆，资金放大10倍)</p>
          <ul class="ksxz">
            <li
              v-for="(item,index) in currentMultiple"
              :key="index"
              :class="{capital_ul2_active: cut == index}"
              @click="setCut(index,item)"
            >
              <p>
                <span class="b30">{{item[0]}}</span>倍
              </p>
              <p>月利率{{item[2]}}%</p>
              <p>{{item[3]}}{{ $t('operatevip.yuan') }}</p>
            </li>
          </ul>
        </div>
        <div class="trader-at-r">
          <p class="trader-at-tit">第三步：选择你的配资周期</p>
          <p class="mar-l-6">
            期限：自动延期&nbsp;账户管理费：
            <span class="cor-y m_span1">{{fee}}</span>{{ $t('operatevip.yuan') }}
          </p>
          <p class="note">备注：自动延期，单票持仓100%</p>
          <p class="trader-at-tit">第三步：选择开始交易时间</p>
          <p class="mar-l-6" id="p1">
            <span class="ljsx capital_ul2_active">立即生效</span>
          </p>
          <p class="trader-at-tit">第五步：确认配资信息</p>
          <table border="1" class="tab">
            <tr>
              <th>配资须知</th>
              <th>盈利100%全归您</th>
            </tr>
            <tr>
              <td>总配资资金</td>
              <td>
                <span class="cor-y allMoney">{{allMoney}}{{ $t('operatevip.yuan') }}</span>&nbsp;
                <span class="span1">{{principal}}(本金)+{{money}}(配资资金)</span>
              </td>
            </tr>
            <tr>
              <td>亏损警戒线</td>
              <td>
                <span class="cor-y span2">{{warning}}{{ $t('operatevip.yuan') }}</span>
                &nbsp;(预警线=配资资金*{{info.warning}})
              </td>
            </tr>
            <tr>
              <td>亏损平仓线</td>
              <td>
                <span class="cor-y span3">{{close}}{{ $t('operatevip.yuan') }}</span>
                &nbsp;(平仓线=配资资金*{{info.close}})
              </td>
            </tr>
          </table>
        </div>
        <div class="clear"></div>
      </div>
      <p class="tet-cen cor-y">
        备注：您需要支付的金额为：保证金
        <span class="span4">{{principal}}</span>{{ $t('operatevip.yuan') }}+
        <span class="m_span3">{{fee}}</span>{{ $t('operatevip.yuan') }}(管理费)=
        <span class="m_span2">{{payMoney}}</span>{{ $t('operatevip.yuan') }}
      </p>
      <p class="tet-cen">如果您不清楚规则，或有其他疑问，请联系客服</p>
      <p class="tet-cen p2">
        <input type="checkbox" class="check" v-model="agree">
        <span>我已阅读并同意</span>
        <router-link to="/operate/protocol">《配资合作协议》</router-link>
      </p>
      <el-button class="cp-btn" type="danger" @click="operateBtn" :disabled="disabled">我要配资</el-button>
      <div class="border"></div>
      <div class="cpxz">
        <div class="cpxz-tit">配资须知</div>
        <div v-html="tips"></div>
        &lt;!&ndash; <p>1、不得购买S、ST、*ST、S*ST、SST、以及被交易所特别处理的股票；</p>
        <p>2、不得购买权证类可以T+0交易的证券；</p>
        <p>3、不得购买或持有上市新股，次新股（或复牌股票）及不设涨跌停板限制的股票；</p>
        <p>4、可以满仓单支股票，但请保持账户内有足够的保证金，总配资资金高于预警线，以免低于平仓线，被风控部门强制平仓；</p>
        <p>5、不得进行坐庄、对敲、接盘、大宗交易、内幕信息等违反股票交易法律法规及证券公司规定的交易。</p>
        <p>6、全程无需支付账户管理费，股市有风险，投资需谨慎！市场风险莫测，务请谨慎行事！</p>
        <p>7、资金使用期限：资金免费提供，可配资15个交易日，配1-5倍 盈利70%全归您；</p>
        <p style="font-size: 18px; color: #cc0000;">第15个交易日14:30自动终止配资并结算</p>
        <p>8、风险保证金：在您配资出现亏损后用于支付亏损金，结束时如无亏损全额退还，保证金越低收益越大，同时风险也越大；</p>
        <p style="font-size: 18px; color: #cc0000;">（如何追加保证金？登陆成功后，进入“我的账户”，找到方案，点击“追加保证金”按钮）</p>
        <p>9、亏损警戒线：当总配资资金低于警戒线以下时，只能平仓不能建仓，需要尽快补充风险保证金，以免低于亏损平仓线被平仓；</p>
        <p>10、亏损平仓线：当总配资资金低于平仓线以下时，我们将有权把您的股票进行平仓，为避免平仓发生，请时刻关注风险保证金是否充足；</p>
        <p>11、开始交易时间：一般选择下个交易日，如看中行情急需交易，可直接选择今天交易。</p>
        <p>12、平仓备注：符合平仓条件且当前交易日平仓失败的，在下一个交易日9:20以集合竞价方式平仓。</p>&ndash;&gt;
      </div>-->
    </div>
    <!-- 购买成功弹窗-->
    <span class="instead"></span>
    <Operatesuccess class="operate-success" :paymoney="payMoney" :close="close" :fee="dayFee" :allmoney="allMoney"
      :principal="principal" :warning="warning" :voucher_management="voucher_management" :dateText="$t('operatevip.month')" :directionCapital="direction_capital"></Operatesuccess>
    <!--余额不足-->
    <Operatefail :principal="principal" :allmoney="allMoney" :fee="dayFee" :close="close" :warning="warning"
      :paymoney="payMoney" :balance="balance" :lack="lack" class="operate-fail"></Operatefail>
    <!-- ============================== Start change channel popup ========================== -->
    <el-dialog :visible.sync="showTradeChannelPopup" width="40%" center custom-class="tradingChannelPop">
      <div v-html="trade_rules_content_top"></div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="agreeTradeRules()"
          style="background-color: var(--baseColor);border-color:var(--baseColor) width: 200px">{{ $t('operatevip.understand') }}
        </el-button>
        <div v-html="trade_rules_content_bottom" style="padding-top: 10px"></div>
      </span>
    </el-dialog>
    <!-- ============================== end change channel popup ========================== -->
  </div>
</template>
<script>
import $ from "jquery";
import Operatesuccess from "./module/operatesuccess";
import Operatefail from "./module/operatefail";
import CommonLoading from "./common/commonLoading";
export default {
  components: {
    Operatesuccess,
    Operatefail,
    CommonLoading
  },
  data() {
    return {
      info: {
        close: 0.3,
        delay: 20,
        explain: '',
        max_num: 2000000,
        min_num: 2000,
        min_time: 2,
        name: this.$t('operatevip.day'),
        times: 100,
        warning: 0.5
      },
      multiple: [],
      multiple_short: [],
      direction_capital: 0,
      direction_capital_enable: 0,
      is_short_trading_enable: 0,
      cut: 0, //控制杠杆样式
      principal: "", //本金
      money: 0.0, //借款金额
      allMoney: 0.0, //总配资资金
      fee: 0.0, //账户管理费
      dayFee: 0.0, //按天的管理费
      warning: 0.0, //预警线
      close: 0.0, //平仓线
      payMoney: 0.0, //付款金额
      agree: true, //同意协议
      balance: 0.0, //余额
      lack: 0.0, //余额不足的差价
      disabled: false, //我要配资按钮的 防止连点
      tips: "", //配资须知
      pitchMultiple: '',   //配资利率
      voucher_management: 0.00,
      user: {
        loginType: false,
        //代金券
        voucher_management: 0.00,
        //可用余额
        cash: 0.00,
        voucher_ratio: 0.0,
        voucher_ratio_short: 0.0,
      },
      trade_channel_status: "",
      showTradeChannelPopup: false,
      trade_rules_content_top: "",
      trade_rules_content_bottom: "",
      fullscreenLoading: false
    };
  },
  computed: {
    currentMultiple() {
      return this.direction_capital == 1 ? this.multiple_short : this.multiple;
    },
    currentVoucherRatio() {
      const ratio = this.direction_capital == 1
        ? this.user.voucher_ratio_short
        : this.user.voucher_ratio;
      return parseFloat(ratio) || 0;
    },
  },
  mounted() {
    if (this.$store.state.loginType) {
      this.getUserinfo();
    } else {
      this.getMonthInfo();
    }
  },
  methods: {
    toggleRadio(val) {
      this.direction_capital = val;
      this.cut = 0;
      // this.principalChange();
    },
    processMultipleList(list) {
      let that = this;
      $.each(list, function (index, item) {
        item.push((item[1] * 100).toFixed(2));
        item.push(that.info.min_num * item[0]);
      });
      list.sort(function (a, b) {
        return b[0] - a[0];
      });
    },
    getUserinfo() {
      let that = this;
      that
        .$http({
          url: "/app/User/user",
          method: "post",
          data: {

          }
        })
        .then(function (res) {
          if (res.data.status == 200) {
            that.user.loginType = true;
            that.user.cash = res.data.data.cash;
            that.user.voucher_management = res.data.data.voucher_management;
            that.user.voucher_ratio = res.data.data.voucher_ratio;
            that.user.voucher_ratio_short = res.data.data.voucher_ratio_short;
            that.trade_channel_status = res.data.data.trade_channel_status;
            that.getMonthInfo();
          } else {
            that.user.loginType = false;
            that.$message.error(that.$t(res.data.msgId));
          }
        });
    },
    //获取月配信息
    getMonthInfo() {
      let that = this;
      that
        .$http({
          url: "/app/CapitalType/vip_info",
          method: "post",
          data: {

          }
        })
        .then(function (res) {
          if (res.data.status == 200) {
            var data = res.data.data;
            that.info = data;
            that.multiple = res.data.multiple || [];
            that.multiple_short = res.data.multiple_short || [];
            that.direction_capital_enable = parseInt(res.data.direction_capital_enable);
            that.is_short_trading_enable = parseInt(res.data.is_short_trading_enable);
            that.processMultipleList(that.multiple);
            that.processMultipleList(that.multiple_short);
            const list = that.currentMultiple;
            that.principal = that.info.min_num; //本金
            that.money = list[that.cut][3]; //借款金额
            that.allMoney = that.principal + that.money; //总资金
            that.fee = (
              list[that.cut][3] * list[that.cut][1]
            ).toFixed(2); //管理费
            that.dayFee = parseFloat(that.fee).toFixed(2); //按天配资的管理费
            that.warning = that.principal * that.info.warning + that.money; //警戒线
            that.close = that.principal * that.info.close + that.money; //平仓线
            that.pitchMultiple = list[that.cut][2];
          } else {
            that.$message.error(that.$t(res.data.msgId));
          }
        });
    },
    //选择杠杆
    setCut(index, item) {
      let that = this;
      that.cut = index;
      that.money = item[3]; //借款金额
      that.fee = (item[3] * item[1]).toFixed(2); //管理费
      that.dayFee = parseFloat(that.fee).toFixed(2); //按天配资的管理费
      that.allMoney = that.money + that.principal; //总配资资金
      that.warning = that.principal * that.info.warning + that.money; //警戒线
      that.close = that.principal * that.info.close + that.money; //平仓线
      // that.payMoney = (that.principal + parseFloat(that.fee)).toFixed(2); //付款金额
      that.pitchMultiple = item[2];    //利率
    },
    //本金变动计算
    principalChange() {
      let that = this;
      if (that.principal === "" || that.principal === null || that.principal === undefined) {
        that.zero();
        return;
      }
      let principal = Number(that.principal);
      if (principal >= Number(that.info.max_num)) {
        principal = Number(that.info.max_num);
      }
      that.principal = principal;
      $.each(that.multiple, function (index, item) {
        item[3] = principal * item[0];
      });
      $.each(that.multiple_short, function (index, item) {
        item[3] = principal * item[0];
      });
      const list = that.currentMultiple;
      that.money = list[that.cut][3];
      that.fee = (list[that.cut][3] * list[that.cut][1]).toFixed(2);
      that.dayFee = parseFloat(that.fee).toFixed(2);
      that.allMoney = that.money + that.principal;
      that.warning = that.principal * that.info.warning + that.money;
      that.close = that.principal * that.info.close + that.money;
    },
    zero() {
      let that = this;
      $.each(that.multiple, function (index, item) {
        item[3] = "0.00";
      });
      $.each(that.multiple_short, function (index, item) {
        item[3] = "0.00";
      });
      that.money = "0.00"; //借款金额
      that.fee = "0.00"; //管理费
      that.dayFee = "0.00"; //按天配资的管理费
      that.allMoney = "0.00"; //总操盘资金
      that.warning = "0.00"; //警戒线
      that.close = "0.00"; //平仓线
      that.payMoney = "0.00"; //付款金额
    },
    //我要配资操作
    operateBtn() {
      let that = this;
      if (sessionStorage.getItem("token") == null) {
        that.$message.error(that.$t('operatevip.loginFirst'));
      } else if (that.agree == false) {
        that.$message.error(that.$t('operatevip.readAgreement'));
      } else {
        that.disabled = true;
        setTimeout(function () {
          that.disabled = false;
        }, 3000);
        //流程：请求余额  显示 余额不足弹窗 或者 确认购买弹窗
        /*if (that.user.cash > that.payMoney) {
          //余额充足

        } else {
          //余额不足
          $(".operate-fail").fadeIn(100);
        }*/
        if (that.trade_channel_status == 1) {
          that.getTradeChannel();
        } else {
          // that.fullscreenLoading = true;
          that.$refs.commonLoader.showCommonLoadigIcon();
          that
            .$http({
              url: "/app/Capital/apply_vip",
              method: "post",
              data: {
                bond: that.principal,
                multiple: that.currentMultiple[that.cut][0],
                direction_capital: that.direction_capital,
              }
            })
            .then(function (res) {
              if (res.data.status == 200) {
                if (res.data.code == 1) {
                  $(".operate-success").fadeIn(100);
                } else if (res.data.code == 2) {
                  that.getTradeChannel();
                } else if (res.data.code == 0 || res.data.code == -1) {
                  that.$message.error(that.$t(res.data.msgId));
                }
              } else {
                that.$message.error(that.$t(res.data.msgId));
              }

            }).finally(() => {
              // that.fullscreenLoading = false;
              that.$refs.commonLoader.hideCommonLoadigIcon();
            });
        }
        /* that
           .$http({
             url: "/",
             method: "post",
             data: {
               nozzle: "user",
               token: sessionStorage.getItem("token")
             }
           })
           .then(function(res) {
             if (res.data.code == 1) {
               that.balance = parseFloat(res.data.data.cash);
               if (that.balance > that.payMoney) {
                 //余额充足
                 that
                   .$http({
                     url: "/",
                     method: "post",
                     data: {
                       nozzle: "apply_month",
                       token: sessionStorage.getItem("token"),
                       bond: that.principal,
                       multiple: that.currentMultiple[that.cut][0]
                     }
                   })
                   .then(function(res) {
                     if (res.data.code == 1) {
                       $(".operate-success").fadeIn(100);
                     } else if (res.data.code == 0 || res.data.code == -1) {
                       that.$message.error(that.$t(res.data.msgId));
                     }
                   });
               } else {
                 //余额不足
                 that.lack = that.payMoney - that.balance;
                 $(".operate-fail").fadeIn(100);
               }
             } else if (res.data.code == 0 || res.data.code == -1) {
               that.$message.error(that.$t(res.data.msgId));
             }
           });*/
      }
    },

    // ============= get the content of trade channel popup agreement ===========
    getTradeChannel() {
      let that = this;
      that
        .$http({
          url: "/app/User/trade_popup",
          method: "post",
          data: {
            
          },
        })
        .then(function (res) {
          if (res.data.status == 200) {
            that.trade_rules_content_top = res.data.data.content_top;
            that.trade_rules_content_bottom = res.data.data.content_bottom;
            that.showTradeChannelPopup = true;
          } else {
          }
        });
    },

    // ============================== Click agree the trade rules ========================
    agreeTradeRules() {
      let that = this;
      that
        .$http({
          url: "/app/TradeChannalLog/modify_trade_status",
          method: "post",
          data: {
            trade_channel_status: 1,
          },
        })
        .then(function (res) {
          if (res.data.status == 200) {
            that.$message({
              message: that.$t(res.data.msgId),
              type: "success",
              duration: 1000,
            });
            that.showTradeChannelPopup = false;
            that.trade_channel_status = 0;
          } else {
            that.$message.error(that.$t(res.data.msgId));
          }
        });
    },

    isMultiple() {
      let that = this;
      let principal = parseInt(that.principal);
      if (isNaN(principal) || principal === '' || principal < Number(that.info.min_num) || principal > Number(that.info.max_num)) {
        that.principal = 0;
        that.zero();
      } else {
        principal = parseInt(principal / 100) * 100;
        that.principal = principal;
      }
      that.principalChange();
    },
    //配资须知
    getTips() {
      let that = this;
      that
        .$http({
          url: "/",
          method: "post",
          data: {
            nozzle: "operate_notice"
          }
        })
        .then(function (res) {
          if (res.data.code == 1) {
            that.tips = res.data.data;
          } else if (res.data.code == 0 || res.data.code == -1) {
            that.$message.error(that.$t(res.data.msgId));
          }
        });
    },
    recalculatePayMoney() {
      let that = this;

      const fee = parseFloat(that.fee) || 0;
      const principal = parseFloat(that.principal) || 0;
      const userVoucher = parseFloat(that.user.voucher_management) || 0;

      if (that.user.loginType) {
        const voucherUsed = fee * that.currentVoucherRatio;
        that.voucher_management = voucherUsed > userVoucher ? userVoucher : voucherUsed;
        that.voucher_management = parseFloat(that.voucher_management) || 0;
      }

      that.payMoney = (
        principal +
        fee -
        Number(that.voucher_management)
      ).toFixed(2);
    },
  },
  watch: {
    fee() {
      this.recalculatePayMoney();
    },
    direction_capital() {
      this.$nextTick(() => {
        this.principalChange();
        this.recalculatePayMoney();
      });
    },
  },
};
</script>
<style scoped>
@import url("./../assets/css/operate.css");

.operate-input {
  margin-left: 6%;
  width: 70%;
  height: 40px;
}

.operate-success,
.operate-fail {
  display: none;
}

.assist_title {
  font-weight: bold;
  font-size: 20px;
}

.multiple {
  border-radius: 4px;
  padding: 15px 0;
  border: 1px solid #9a9a9a;
}

.multiple p {
  text-align: center;
  line-height: 1.6;
  font-size: 18px;
  color: #98989a;
}

.multiple_detail {
  /*padding-top: 10px;*/
}

.capital_ul2_active p {
  color: #FFFFFF !important;
}

.money_info {
  border-radius: 4px;
}

.money_info p {
  font-size: 16px;
}

.info_title {
  font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei", "微软雅黑", Arial, sans-serif;
  font-weight: bold;
  font-size: 16px;
}

.multiple_box {
  width: 19%;
  float: left;
  margin-right: 1.25%;
}

.multiple_box:last-child {
  margin-right: 0;
}

.infoColor {
  color: #909399;
}

.capital_ul2_active {
  background: var(--baseColor);
  color: #fff !important;
  border: 1px solid var(--baseColor) !important;
}
</style>
<style>
.tradingChannelPop .el-dialog__body {
  padding: 0px 20px;
}

/* .tradingChannelPop .el-dialog__header {
  display: none;
} */
</style>





// WEBPACK FOOTER //
// src/components/operatevip.vue